import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _find from 'lodash/find';
import _map from 'lodash/map';

import {
  AppState,
} from 'interfaces/store';
import {
  setLayerAlignmentItem,
} from 'store/actions/calculator';
import { LayerAlignmentItem } from 'interfaces/calculator';
import ButtonType from 'components/atoms/Button/type';

const useLayerAlignmentState = () => {
  const dispatch = useDispatch();
  const {
    layer: {
      alignmentItems = [],
    },
  } = useSelector(({ calculator }: AppState) => calculator);

  const alignmentActiveItem = _find(alignmentItems, { selected: true });
  const alignmentItemsButtons = _map(alignmentItems, (item) => ({
    type: ButtonType.OUTLINE,
    children: item.label,
    active: item.selected,
    icon: item.Icon,
    data: item,
  }));
  const setAlignmentItem = useCallback((newItem: LayerAlignmentItem) => {
    dispatch(setLayerAlignmentItem(newItem));
  }, [dispatch]);

  return {
    alignmentItems: alignmentItems || [],
    alignmentItemsButtons,
    alignmentActiveItem,
    setLayerAlignmentItem: setAlignmentItem,
  };
};

export default useLayerAlignmentState;
